// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"1f4e355d","703":"3b0112aa","735":"1ec443ed","787":"4d76f5fd"}[chunkId] + ".chunk.js";
};